import React, { useEffect, useState } from "react";
import ReactECharts from 'echarts-for-react';

export default function Speedgauge () {

    const [gaugeoptions,setGaugeoptions] = useState({})

    var options = { 
        series: [
            {
              type: 'gauge',
              progress: {
                show: true,
                width: 18
              },
              axisLine: {
                lineStyle: {
                  width: 18
                }
              },
              axisTick: {
                show: false
              },
              splitLine: {
                length: 15,
                lineStyle: {
                  width: 2,
                  color: '#999'
                }
              },
              axisLabel: {
                distance: 25,
                color: '#999',
                fontSize: 14
              },
              anchor: {
                show: true,
                showAbove: true,
                size: 25,
                itemStyle: {
                  borderWidth: 10
                }
              },
              title: {
                show: false
              },
              detail: {
                valueAnimation: true,
                fontSize: 32,
                offsetCenter: [0, '70%']
              },
              data: [
                {
                  value: 65
                }
              ]
            }
        ]
    }

    useEffect(() => {
        setGaugeoptions(options)
    },[])

    return(
        <div style={{height: '100%', width: '100%',  overflow: 'auto'}}>
            <ReactECharts option={gaugeoptions} style={{ height: '100%', width: '100%', marginTop:"0px" }}/>
        </div>
        
    )
}